import React from 'react';
import {useTranslation} from "react-i18next";
import Money from "../../../Common/Money";
import {ReactComponent as PlusSVG} from "../../../../../images/icons/plus.svg";
import {ReactComponent as MinusSVG} from "../../../../../images/icons/minus.svg";
import CartItemItems from "./CartItemItems";
import AppConfig from "../../../../services/AppConfig";
import {ReactComponent as MenuItemDarkIco} from "../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as EditIco} from "../../../../../images/icons/edit.svg";

interface Props {
    item: Record<string, any>;
    itemView: Record<string, any>;
    handleChangeQuantity: (
        event: React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>,
        item: Record<string, any>,
        value: any,
        prevent?: boolean,
    ) => Promise<void>;
    onClick: (item: Record<string, any>) => void;
    promotion: any;
    tips: any[];
}

const CartItem = ({itemView, item, handleChangeQuantity, onClick, promotion, tips}: Props) => {
    const {t} = useTranslation();
    const name = itemView ? itemView.translation.name : item.name;

    const renderItemPrice = () => {
        if (item.discount_money && item.discount_money.amount !== 0) {
            const subTotalPrice = item.total_money.amount + item.discount_money.amount;

            return (
                <>
                    <span className="text-muted me-2">
                        <del>
                        <Money
                            value={subTotalPrice}
                            currency='PLN'/>
                        </del>
                    </span>
                    <span className="text-danger">
                    <Money
                        value={item.total_money.amount}
                        currency='PLN'/>
                    </span>
                </>
            )
        }

        return (
            <Money
                value={item.total_money.amount}
                currency='PLN'/>
        )
    }

    return (
        <div className={"cart-item"} onClick={() => onClick(item)}>
            <div className={"cart-item-img"}>
                <div className="position-relative">
                    {
                        itemView && itemView.image_small ? (
                            <img src={itemView.image_small} alt={t("common.word.product_image")}/>
                        ) : (
                            AppConfig.isDarkMode() ?
                                <MenuItemDarkIco className="img"/> : <MenuItemIco className="img"/>
                        )
                    }
                    <div className="edit-icon-container">
                        <EditIco/>
                    </div>
                </div>
            </div>
            <div className={"cart-item-body"}>
                <h3>{name}</h3>
                <div className={"cart-item-items"}>
                    <CartItemItems orderItem={item}/>
                </div>
                {promotion && (
                    <div className={"cart-item-promotion text-success"}>
                        {promotion.name}
                    </div>
                )}
                <div className={"cart-item-prices"}>
                    {renderItemPrice()}
                </div>
                <div className={"cart-item-quantity-container"}>
                    <div>
                        {!tips.includes(item.uid) && (
                            <div className="input-group input-group-sm input-group-quantity">
                                <div className="input-group-prepend">
                                    <button type="button"
                                            aria-label={`${t("common.action.decrease_quantity")} ${name}`}
                                            className="btn btn-default btn-icon"
                                            onClick={(event) => handleChangeQuantity(event, item, item.quantity - 1, true)}>
                                        <MinusSVG aria-hidden="true"/>
                                    </button>
                                </div>
                                <span
                                    className="input-group-text">{item.quantity}</span>
                                <div className="input-group-append">
                                    <button type="button"
                                            aria-label={`${t("common.action.increase_quantity")} ${name}`}
                                            className="btn btn-default btn-icon"
                                            onClick={(event) => handleChangeQuantity(event, item, item.quantity + 1, true)}>
                                        <PlusSVG aria-hidden="true"/>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {item.comment && (
                    <div className="order-comment mt-2 rounded-2">
                        <p className="mb-0">{item.comment}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CartItem;